import { ErrorResponse } from './../models/error.model';
import { NotificationsService } from './../services/notifications.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { UtilsService } from '../services/utils.service';
import { SideNavMenu } from '../models/side-nav-menu.model';
import { Notification } from '../models/notification.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { FastQuoteDialogComponent } from '../dialogs/fast-quote-dialog/fast-quote-dialog.component';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit, OnDestroy {
    public environment = environment;
    public username = 'Usuario';
    public userType = 'Usuario';
    public showSideBar = true;
    mobile = false;

    public sideNavMenus: SideNavMenu[] = [
        { icon: 'home', text: 'Home', redirect: ['home'] }
    ];

    public routerSteps: string[] = [];

    @Input()
    titulo = '';

    @Input()
    descripcion = '';

    notificationsCount = 0;
    notifications: Notification[] = [];
    notificationsInterval: any;

    constructor(
        private authService: AuthService,
        private utilsService: UtilsService,
        public router: Router,
        private notificationsService: NotificationsService,
        private dialog: MatDialog,
        breakpointObserver: BreakpointObserver,
    ) {
        const user = this.authService.getUser();
        if (user?.tipo) {
            if (user.tipo === 'CORPORATIVO') {
                this.sideNavMenus = [
                    { icon: 'home', text: 'Home', redirect: ['corporativo', 'home'] },
                    { icon: 'business', text: 'Oficinas', redirect: ['oficinas'], submenus: [
                        { text: 'Nueva oficina', redirect: ['oficinas', 'nueva'] },
                    ] },
                    { icon: 'people', text: 'Agentes', redirect: ['agentes'] },
                    { icon: 'person_search', text: 'Propietarios', redirect: ['propietarios'] },
                    { icon: 'person_outline', text: 'Inquilinos', redirect: ['inquilinos'] },
                    { icon: 'house', text: 'Propiedades', redirect: ['propiedades'] },
                    { icon: 'assignment_turned_in', text: 'Fianzas', redirect: ['garantias'] },
                    { icon: 'article', text: 'Locación', redirect: ['contratos'], submenus: [                        
                        { text: 'Nuevo Contrato', redirect: ['contratos', 'nueva'] },
                    ] },
                    { icon: 'attach_money', text: 'Cotizaciones', redirect: ['cotizaciones'], submenus: [
                        { text: 'Cotización Rápida', onClick: () => this.dialog.open(FastQuoteDialogComponent, { width: '900px' }) },
                        { text: 'Nueva cotización', redirect: ['cotizaciones', 'nueva'] },
                    ] },
                    { icon: 'info', text: 'Informes', redirect: ['informes'] },
                    { icon: 'border_color', text: 'Firmas', redirect: ['firmas-pendientes'] },
                    { icon: 'electric_bolt', text: 'Garantías rápidas', redirect: ['garantias-rapidas'] },
                    { icon: 'badge', text: 'Comerciales', redirect: ['comerciales'], submenus: [
                        { text: 'Nuevo comercial', redirect: ['comerciales', 'nuevo'] },
                    ] },
                    { icon: 'settings', text: 'Configuración', redirect: ['configuracion'], submenus: [
                        { text: 'Zonas / Agrupaciones', redirect: ['configuracion', 'calculadora', 'zonas'] },
                        { text: 'Tipos de Descuento', redirect: ['configuracion', 'calculadora', 'tipos-descuento'] },
                        { text: 'Medios de Pago', redirect: ['configuracion', 'calculadora', 'medios-de-pago'] },
                        { text: 'Producto', redirect: ['configuracion', 'calculadora', 'producto'], submenus: [
                            { text: 'Vivienda', redirect: ['configuracion', 'calculadora', 'producto', 'vivienda'] },
                            { text: 'Comercial', redirect: ['configuracion', 'calculadora', 'producto', 'comercial'] },
                        ] },
                        { text: 'Servicios Contratados', redirect: ['configuracion', 'calculadora', 'servicios-contratados'] },
                        { text: 'Servicios', redirect: ['servicios'] },
                    ] },
                ];
            } else if (user.tipo === 'OFICINA') {
                this.sideNavMenus = [
                    { icon: 'home', text: 'Home', redirect: ['oficina', 'home'] },
                    { icon: 'people', text: 'Agentes', redirect: ['agentes'], submenus: [
                        { text: 'Nuevo agente', redirect: ['agentes', 'nuevo'] },
                    ] },
                    { icon: 'person_search', text: 'Propietarios', redirect: ['propietarios'] },
                    { icon: 'person_outline', text: 'Inquilinos', redirect: ['inquilinos'] },
                    { icon: 'house', text: 'Propiedades', redirect: ['propiedades'] },
                    { icon: 'assignment_turned_in', text: 'Garantías', redirect: ['garantias'] },
                    { icon: 'attach_money', text: 'Cotizaciones', redirect: ['cotizaciones'], submenus: [
                        { text: 'Cotización Rápida', onClick: () => this.dialog.open(FastQuoteDialogComponent, { width: '900px' }) },
                        { text: 'Nueva cotización', redirect: ['cotizaciones', 'nueva'] },
                    ] },
                    { icon: 'settings', text: 'Configuración', redirect: ['configuracion'] },
                ];
            } else if (user.tipo === 'AGENTE') {
                this.sideNavMenus = [
                    { icon: 'home', text: 'Home', redirect: ['agente', 'home'] },
                    { icon: 'person_search', text: 'Propietarios', redirect: ['propietarios'], submenus: [
                        { text: 'Nuevo propietario', redirect: ['propietarios', 'nuevo'] },
                    ] },
                    { icon: 'person_outline', text: 'Inquilinos', redirect: ['inquilinos'] },
                    { icon: 'house', text: 'Propiedades', redirect: ['propiedades'], submenus: [
                        { text: 'Nueva propiedad', redirect: ['propiedades', 'nueva'] },
                    ] },
                    { icon: 'assignment_turned_in', text: 'Garantías', redirect: ['garantias'] },
                    // { icon: 'monetization_on', text: 'Tipo de cambio', redirect: ['tipo-de-cambio'], submenus: [
                    //     { text: 'Monedas', redirect: ['tipo-de-cambio', 'monedas']},
                    // ] },
                    { icon: 'attach_money', text: 'Cotizaciones', redirect: ['cotizaciones'], submenus: [
                        { text: 'Cotización Rápida', onClick: () => this.dialog.open(FastQuoteDialogComponent, { width: '900px' }) },
                        { text: 'Nueva cotización', redirect: ['cotizaciones', 'nueva'] },
                    ] },
                    { icon: 'settings', text: 'Configuración', redirect: ['configuracion'] },
                ];
            }
        }
        breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
            if ((this.mobile && !result.matches) || (!this.mobile && result.matches)) {
                this.onMobileChanges(result.matches);
            }
        });
    }

    ngOnInit() {
        const user = this.authService.getUser();
        if (user) {
            if (user.tipo === 'AGENTE' && user.agente?.nombre) {
                this.username = this.utilsService.beautifyText(user.agente.nombre);
            } else if (user.tipo === 'OFICINA' && user.oficina?.nombreResponsable) {
                this.username = this.utilsService.beautifyText(user.oficina.nombreResponsable);
            } else {
                this.username = this.utilsService.beautifyText(user.email);
            }
            this.userType = user.tipo === 'CORPORATIVO' ? 'Administrador' : user.tipo === 'OFICINA' ? 'Broker de oficina' : user.tipo === 'AGENTE' ? 'Agente' : 'Usuario';
        }
        this.manageRouterHistory();
        this.getNotificationCount();
        this.notificationsInterval = setInterval(() => this.getNotificationCount(), 60000);
    }

    ngOnDestroy(): void {
        clearInterval(this.notificationsInterval);
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    manageRouterHistory() {
        const queryParamsLocation = this.router.url.search(/\?/);
        this.routerSteps = this.router.url.substring(0, queryParamsLocation !== -1 ? queryParamsLocation : this.router.url.length).split('/').filter(route => !!route);
    }

    redirectTo(index: number) {
        const url = '/' + this.routerSteps.slice().splice(0, index + 1).join('/');
        this.router.navigateByUrl(url).catch(() => {});
    }

    getNotificationCount() {
      this.notificationsService.getNotificationCount().subscribe(count => {
        this.notificationsCount = count;
      }, () => {});
    }

    getNotifications() {
      this.notificationsService.getNotifications(0, 3).subscribe(response => {
        this.notifications = response.body ?? [];
      }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener notificaciones', error.error?.descripcion ?? ''));
      this.getNotificationCount();
    }

    onMobileChanges(newValue: boolean) {
        this.mobile = newValue;
        this.showSideBar = !this.mobile;
    }
}
